import { Layout, Alert, Flex, Typography, AlertProps } from "antd";
import "../styles/consultComplete.scss"
import { useState } from "react";

const { Header, Content, Footer } = Layout
const { Title } = Typography

const ConsultLinkExpired = () => {
    const [title] = useState("Invalid TeleHealth Link")
    const [alertMessage] = useState<AlertProps>({
        message: "Consult Link Expired",
        description: "The Telehealth consult you are trying to join has expired.",
        type: "error",
    })

    return (
        <Flex gap="middle" wrap>
            <Layout>
                <Header />
                <div className="complete_container">
                    <Content>
                        <div className="title_container">
                            <Title level={2}>{title}</Title>
                        </div>
                        <div className="info_container">
                            <Alert
                                showIcon
                                style={{ justifyContent: 'flex-start', alignItems: 'flex-start', textAlign: 'left' }}
                                type={alertMessage.type}
                                message={alertMessage.message}
                                description={alertMessage.description}
                            />
                        </div>
                    </Content>
                </div>
                <Footer />
            </Layout>
        </Flex>
    )
}

export default ConsultLinkExpired 